export enum EEditStatus {
  Init = 'init',
  Edit = 'edit',
  Preview = 'preview',
  Saved = 'saved',
  Failed = 'failed',
}

export type TEditStatus = {
  status: EEditStatus;
};
